/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_ProducersInputs */

const en_search_producers = /** @type {(inputs: Search_ProducersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search producers...`)
};

const es_search_producers = /** @type {(inputs: Search_ProducersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar productores...`)
};

/**
* | output |
* | --- |
* | "Search producers..." |
*
* @param {Search_ProducersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_producers = /** @type {((inputs?: Search_ProducersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_ProducersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_producers(inputs)
	return es_search_producers(inputs)
});